// import Logger from '../log/Logger'

class RavenErrorHandlerPlugin {
  static install (Vue, options) {
    Vue.mixin({
      methods: {
        $reportError (error) {
          console.log(error)

          // TODO: use logger
/*          if (typeof options.raven === 'undefined') {
            return
          }

          options.raven.captureException(error, {
            extra: {
              propsData: this.$options.propsData,
              object: error
            }
          }) */
        }
      }
    })
  }
}
export default RavenErrorHandlerPlugin



// WEBPACK FOOTER //
// ./src/exceptions/RavenErrorHandlerPlugin.js